import { Text } from '@backyard-ui/core';

import { type Pack } from '@/infra/services/catalog/product/get-product-info/model';
import { formatPrice } from '@/utils/price/formatPrice';

import { styles } from './Packing.styles';

interface PackingProps {
  pack?: Pack;
}

export default function Packing(props: Readonly<PackingProps>) {
  const { pack } = props;

  const classNames = styles();

  if (!pack?.label || !pack.price) {
    return null;
  }

  const { label, packaging, price, translatedUnit } = pack;

  return (
    <div className={classNames.container()}>
      <Text size="md" asChild>
        <span>
          <strong className={classNames.info()}>{`${formatPrice(
            price
          )} / ${label}`}</strong>
          {`cada caixa possui ${String(packaging).replace(
            '.',
            ','
          )}${translatedUnit}`}
        </span>
      </Text>
    </div>
  );
}
